module.exports = __webpack_public_path__ + "assets/img/417d-by.svg";